import AxiosConfig from "@/config/axiosConfig/AxiosConfig";
import config from "@/config";

const OptionService = {
    getOption: async (params) => {
        try {
            const response = await AxiosConfig.get(config.api.option, { params });
            return response.data;
        } catch (error) {
            console.error('Error:', error);
            return Promise.reject(error);
        }
    }
}

export default OptionService;